import { render, staticRenderFns } from "./Subtopics.vue?vue&type=template&id=e804b74a&scoped=true&"
import script from "./Subtopics.vue?vue&type=script&lang=js&"
export * from "./Subtopics.vue?vue&type=script&lang=js&"
import style0 from "./Subtopics.vue?vue&type=style&index=0&id=e804b74a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e804b74a",
  null
  
)

export default component.exports